import { render, staticRenderFns } from "./task-edit.vue?vue&type=template&id=4314b188&scoped=true"
import script from "./task-edit.vue?vue&type=script&lang=js"
export * from "./task-edit.vue?vue&type=script&lang=js"
import style0 from "./task-edit.vue?vue&type=style&index=0&id=4314b188&prod&scoped=true&lang=css"
import style1 from "./task-edit.vue?vue&type=style&index=1&id=4314b188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314b188",
  null
  
)

export default component.exports